module.exports = __webpack_public_path__ + "img/SO.8f540c0d.png";